import HttpAPI from '../../providers/httpService';
import ApiConfig from '../../app_config/apiConfig';
import { WHATSNEWDATA } from '../../constants/reducerTypes';
import UtilityService from '../../providers/utilityService';

const whatsNewPageData = () => dispatch => {
  HttpAPI.requestApi([
    {
      api: ApiConfig.endpointConfig.getWhatsNewData,
    },
  ]).then(
    data => {
      if (data && data[0] && data[0].ok !== false) {
        const whatsNewData = data[0];
        if (whatsNewData.length) {
          dispatch({
            type: WHATSNEWDATA,
            payload: whatsNewData,
          });
        }
      } else {
        dispatch({
          type: WHATSNEWDATA,
          payload: '',
        });
      }
      UtilityService.manageLoader(false);
    },
    error => {
      window.console.log('get error:', error);
      dispatch({
        type: WHATSNEWDATA,
        payload: '',
      });
    },
  );
};
export default whatsNewPageData;
